// ===== POC Cuidados Paliativos (PNCP) - cliente HTTP de /api/palliative =====
// Usa a mesma instância do axios do resto do sistema (base VUE_APP_API_WEB e
// renovação do token no 401). A API responde em PascalCase; cada serviço desta
// pasta converte as respostas para o formato que as telas já usavam nos mocks.

import axios, { userSessionName } from "@/js/axios";
import { Session } from "@/plugins/Session";

const BASE = "/api/palliative";

function authHeaders() {
  const token = Session.get(userSessionName)?.token?.Value;
  return token ? { Authorization: `bearer ${token}` } : {};
}

// Erro com a mensagem da API (MessageDetailsResponse) pronta para mostrar na tela.
export class PalliativeApiError extends Error {
  constructor(error) {
    const response = error && error.response;
    const data = response && response.data;
    let message = "Não foi possível conectar ao servidor.";
    if (response) {
      message = (data && (data.Message || data.message)) || "Não foi possível concluir a operação.";
    }
    super(message);
    this.name = "PalliativeApiError";
    this.status = response ? response.status : null;
  }
}

export async function request(method, path, data, options = {}) {
  try {
    const response = await axios({
      method,
      url: `${BASE}${path}`,
      data,
      headers: authHeaders(),
      ...options
    });
    return response.data;
  } catch (error) {
    throw new PalliativeApiError(error);
  }
}

export const apiGet = (path, options) => request("GET", path, undefined, options);
export const apiPost = (path, data) => request("POST", path, data);
export const apiPut = (path, data) => request("PUT", path, data);
export const apiDelete = (path) => request("DELETE", path);

// Monta "?a=1&b=2" ignorando valores vazios.
export function query(params) {
  const parts = Object.entries(params || {})
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  return parts.length ? `?${parts.join("&")}` : "";
}

// Mostra o erro no <lila-message> da tela (mesmo formato de alerta do sistema).
export function showApiError(vm, alert, error, fallback = "Não foi possível concluir a operação.") {
  console.error("POC Cuidados Paliativos:", error);
  vm.$Utilities.controlAlert(null, alert, "danger", (error && error.message) || fallback);
}
